export default __webpack_public_path__ + "static/media/flyback_controller_ac_psr_neg.dd503804.svg";